/** Los tres estados que la v1.0 no tenía que resolver porque no cargaba nada. */
export function LoadingNotice({ what }: { what: string }) {
  return <p className="notice" role="status" aria-live="polite">Cargando {what}…</p>;
}

export function EmptyNotice({ what }: { what: string }) {
  return (
    <p className="notice notice--empty">
      No hay {what} todavía. Cuando existan, aparecen acá — no se muestran ejemplos en su lugar.
    </p>
  );
}

export function ErrorNotice({ message }: { message: string }) {
  return (
    <p className="notice notice--error" role="alert">
      No se pudo leer el origen de datos: {message}. No se muestra nada en su lugar.
    </p>
  );
}
